import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';
import { supabase } from '@/integrations/supabase/client';

export function AuthPrompt() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    const w = window.open('/auth', '_blank');
    if (!w) {
      // Popup blocked — fall back to in-page navigation
      navigate('/auth', { replace: true });
    }
  }, [navigate]);

  const handleCheckSession = async () => {
    setChecking(true);
    const { data } = await supabase.auth.getSession();
    if (data.session) {
      navigate('/', { replace: true });
    } else {
      // Still no session — try opening auth again
      const w = window.open('/auth', '_blank');
      if (!w) navigate('/auth', { replace: true });
    }
    setChecking(false);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-fos-bg-base p-8">
      <div className="max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-bold">Sign in required</h1>
        <p className="text-fos-text-muted">
          A sign-in tab has been opened. Complete sign in there, then come back here.
        </p>
        <div className="flex flex-col gap-2">
          <Button onClick={handleCheckSession} disabled={checking}>
            {checking ? 'Checking…' : "I've signed in"}
          </Button>
          <Button
            variant="outline"
            onClick={() => {
              const w = window.open('/auth', '_blank');
              if (!w) navigate('/auth', { replace: true });
            }}
          >
            Open sign in again
          </Button>
        </div>
      </div>
    </div>
  );
}
